/** @file Reads rig bones into BoneData with defaults (identity setup, inherit normal, kind bone). */
import type { Pose2DJson } from '@pose2d/format/types';
import { POSE_LAYOUT } from '../../contracts/pose';
import type { BoneData, InheritMode } from '../../skeletonData';
import { indexIn } from './indexIn';

/** Bones in rig order; a parent must precede its child (VALIDATION at `bones[i].parent` otherwise). */
export function readBones(bones: Pose2DJson['bones']): BoneData[] {
  return bones.map((b, i): BoneData => {
    const setup = new Float64Array(POSE_LAYOUT.LOCAL_STRIDE);
    setup[POSE_LAYOUT.X] = b.x ?? 0;
    setup[POSE_LAYOUT.Y] = b.y ?? 0;
    setup[POSE_LAYOUT.ROTATION] = b.rotation ?? 0;
    setup[POSE_LAYOUT.SCALE_X] = b.scaleX ?? 1;
    setup[POSE_LAYOUT.SCALE_Y] = b.scaleY ?? 1;
    setup[POSE_LAYOUT.SHEAR_X] = b.shearX ?? 0;
    setup[POSE_LAYOUT.SHEAR_Y] = b.shearY ?? 0;
    return {
      name: b.name,
      parent: b.parent === undefined ? -1 : indexIn(b.parent, i, `bones[${i}].parent`),
      length: b.length ?? 0,
      inherit: indexIn(b.inherit ?? 0, 5, `bones[${i}].inherit`) as InheritMode,
      setup,
      kind: b.kind ?? 'bone',
    };
  });
}
